module.exports = __webpack_public_path__ + "static/media/silkycloud-pink-3.21c6b9d5.png";